import { Component } from 'js-component-framework';
import SmoothScroll from '../../utilities/SmoothScroll';

/**
 * Component for instantiating Footnotes.
 */
export default class Footnotes extends Component {

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Initalizations
    this.footnotes = document.querySelectorAll('.footnote--slide');
    this.setFootnotePointers();
    this.setFootnoteIndex();
    this.setSmoothScroll = new SmoothScroll('.footnote--slide');
    this.setSmoothScroll.init();
  }

  /**
   * Set links and pointers in report body
   */
  setFootnotePointers() {
    Array.prototype.forEach.call(this.footnotes, (el) => {
      const number = parseInt(el.textContent, 10);

      if (isNaN(number)) {
        return;
      }

      $(el).prepend('[').append(']');
      $(el).wrap(
        `<a
          id="footref-${number}"
          class="sup footnote--slide"
          href="#footnote-${number}"
        >
        </a>`
      );
    });
  }

  /**
   * Set footnote index for ID
   */
  setFootnoteIndex() {
    Array.prototype.forEach.call(this.children.footnote, (el, index) => {
      const noteNumber = index + 1;
      const noteNumberHtml =
        `<a id="footnote-${noteNumber}"
          class="footnote--slide"
          href="#footref-${noteNumber}">
          [${noteNumber}]&ensp;
        </a>`;

      el.insertAdjacentHTML('afterbegin', noteNumberHtml);
    });
  }
}



// WEBPACK FOOTER //
// ./client/js/components/Footnotes/Footnotes.js